"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _request = _interopRequireDefault(require("../../request"));
// 登录模块
var _default = exports.default = {
  getAuthToken: function getAuthToken(data) {
    return (0, _request.default)({
      url: '/public/get-auth-token',
      method: 'post',
      data: data
    });
  },
  sfeLogin: function sfeLogin(data) {
    return (0, _request.default)({
      module: 'CORE',
      url: '/protected/web_login',
      method: 'post',
      data: data,
      hideError: true
    });
  },
  ssoLogin: function ssoLogin(data) {
    return (0, _request.default)({
      module: 'CORE',
      url: '/protected/sso_login',
      method: 'post',
      data: data
    });
  },
  sfeChangeRole: function sfeChangeRole(data, token) {
    return (0, _request.default)({
      module: 'CORE',
      url: '/protected/curr_user_role_change',
      method: 'post',
      data: data,
      headers: {
        token: token
      }
    });
  },
  getUserInfo: function getUserInfo(system) {
    return (0, _request.default)({
      url: '/protected/token-to-system-resources/' + system,
      method: 'post'
    });
  },
  logout: function logout() {
    return (0, _request.default)({
      module: 'CORE',
      url: '/protected/login-out',
      method: 'post'
    });
  },
  jumpSSO: function jumpSSO() {
    return (0, _request.default)({
      module: 'CORE',
      url: '/saml/ssoLogin',
      method: 'get',
      noApi: true
    });
  },
  checkSasToken: function checkSasToken() {
    return (0, _request.default)({
      module: 'CORE',
      url: '/protected/app/check_token',
      method: 'post'
    });
  }
};